import { memo } from 'react';
import Head from 'next/head';

interface IAmpHtmlLinkProps {
  ampHref: string;
}

/**
 * Use this component to apply amphtml link
 * Use this in <Head> Next component
 * @Props ampHref link of amp page version
 * @returns amphtml link
 */
export const AmpHtmlLink = memo<IAmpHtmlLinkProps>(({ ampHref }) => (
  <Head>
    <link rel="amphtml" href={ampHref} />
  </Head>
));
